import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyEnComponent } from './privacy-policy-en.component';
import { PrivacyPolicySkComponent } from './privacy-policy-sk.component';
import { PrivacyPolicyCzComponent } from './privacy-policy-cz.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, PrivacyPolicyEnComponent, PrivacyPolicySkComponent, PrivacyPolicyCzComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {
  @Input() currentLang = 'en';

  // Shared configuration for all language versions
  effectiveDate = '01.09.2025';
  version = '1.0';
  supportEmail = 'legal@sameta.sk';
  websiteUrl = 'https://app.peopleflow.sk/';
  jobPortalUrl = 'https://jobs.peopleflow.sk/';
}
